export default __webpack_public_path__ + "static/media/cari_tempat.cc2d5be8.svg";